const cssColorVars = [
  '--color-bg-default',
  '--color-bg-secondary',
  '--color-bg-brand',
  '--color-bg-link',
  '--color-bg-border',
  '--color-bg-stripe',
  '--color-bg-ghost',
  '--color-bg-tone',
  '--color-bg-soft',
  '--color-bg-system',
  '--color-bg-normal',
  '--color-bg-success',
  '--color-bg-caution',
  '--color-bg-warning',
  '--color-bg-alert',
  '--color-bg-critical',
  '--color-typo-primary',
  '--color-typo-secondary',
  '--color-typo-ghost',
  '--color-typo-brand',
  '--color-typo-system',
  '--color-typo-normal',
  '--color-typo-success',
  '--color-typo-caution',
  '--color-typo-warning',
  '--color-typo-alert',
  '--color-typo-critical',
  '--color-typo-link',
  '--color-typo-link-minor',
  '--color-typo-link-hover',
  '--color-scroll-bg',
  '--color-scroll-thumb',
  '--color-scroll-thumb-hover',
  '--color-control-bg-default',
  '--color-control-typo-default',
  '--color-control-typo-placeholder',
  '--color-control-bg-border-default',
  '--color-control-bg-border-default-hover',
  '--color-control-bg-border-focus',
  '--color-control-bg-focus',
  '--color-control-bg-active',
  '--color-control-bg-primary',
  '--color-control-bg-primary-hover',
  '--color-control-typo-primary',
  '--color-control-typo-primary-hover',
  '--color-control-bg-secondary',
  '--color-control-bg-border-secondary',
  '--color-control-bg-border-secondary-hover',
  '--color-control-typo-secondary',
  '--color-control-typo-secondary-hover',
  '--color-control-bg-ghost',
  '--color-control-bg-ghost-hover',
  '--color-control-typo-ghost',
  '--color-control-typo-ghost-hover',
  '--color-control-bg-clear',
  '--color-control-bg-clear-hover',
  '--color-control-typo-clear',
  '--color-control-typo-clear-hover',
  '--color-control-bg-disable',
  '--color-control-bg-border-disable',
  '--color-control-typo-disable',
] as const;

const cssControlVars = [
  '--control-radius',
  '--control-border-width',
  '--control-height-l',
  '--control-height-m',
  '--control-height-s',
  '--control-height-xs',
  '--control-box-size-m',
  '--control-box-size-l',
  '--control-space-l',
  '--control-space-m',
  '--control-space-s',
  '--control-space-xs',
  '--control-text-size-l',
  '--control-text-size-m',
  '--control-text-size-s',
  '--control-text-size-xs',
] as const;

const cssFontVars = ['--font-primary', '--font-mono'] as const;

const cssSizeVars = [
  '--size-text-2xs',
  '--size-text-xs',
  '--size-text-s',
  '--size-text-m',
  '--size-text-l',
  '--size-text-xl',
  '--size-text-2xl',
  '--size-text-3xl',
  '--size-text-4xl',
  '--size-text-5xl',
  '--size-text-6xl',
  '--line-height-text-2xs',
  '--line-height-text-xs',
  '--line-height-text-s',
  '--line-height-text-m',
  '--line-height-text-l',
] as const;

const cssSpaceVars = [
  '--space-3xs',
  '--space-2xs',
  '--space-xs',
  '--space-s',
  '--space-m',
  '--space-l',
  '--space-xl',
  '--space-2xl',
  '--space-3xl',
  '--space-4xl',
  '--space-5xl',
  '--space-6xl',
] as const;

const cssShadowVars = [
  '--shadow-group',
  '--shadow-layer',
  '--shadow-modal',
] as const;

export const defaultVars = {
  color: {
    primary: cssColorVars,
    accent: cssColorVars,
    invert: cssColorVars,
  },
  control: cssControlVars,
  font: cssFontVars,
  size: cssSizeVars,
  space: cssSpaceVars,
  shadow: cssShadowVars,
} as const;
